import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { useAppSession } from "./state/AppSessionContext.jsx";
import Shell from "./app/components/Shell.jsx";
import Today from "./app/screens/Today.jsx";
import Money from "./app/screens/Money.jsx";
import Food from "./app/screens/Food.jsx";
import Work from "./app/screens/Work.jsx";
import Login from "./app/screens/Login.jsx";

const AdminConsole = lazy(() => import("./admin/AdminConsole.jsx"));

export const OPS_PATH = "/ops-953e0aba";

function Guarded() {
  const { isSignedIn, loading } = useAppSession();

  if (loading) {
    return (
      <div className="gate">
        <div className="gate-card">
          <div className="gate-mark">R</div>
          <p className="gate-sub">Loading…</p>
        </div>
      </div>
    );
  }

  if (!isSignedIn) return <Navigate to="/login" replace />;
  return <Shell />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        path={OPS_PATH}
        element={
          <Suspense fallback={<div className="notice">Loading console…</div>}>
            <AdminConsole />
          </Suspense>
        }
      />

      <Route element={<Guarded />}>
        <Route path="/" element={<Today />} />
        <Route path="/money" element={<Money />} />
        <Route path="/food" element={<Food />} />
        <Route path="/work" element={<Work />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
